import { __assign, __rest } from "tslib";
import React from 'react';
import { Close24 } from '@carbon/icons-react';
import { twMerge } from 'tailwind-merge';
export var CloseButton = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.type, type = _b === void 0 ? 'button' : _b, rest = __rest(_a, ["className", "children", "type"]);
    return (React.createElement("button", __assign({}, rest, { 
        // eslint-disable-next-line react/button-has-type
        type: type, className: twMerge('flex items-center w-fit-content py-3', className) }),
        children,
        React.createElement(Close24, null)));
};
export default CloseButton;
